import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/register/:package?',
    name: 'register',
    component: () => import(/* webpackChunkName: "about" */ '../views/RegisterView.vue'),
    beforeEnter: (to, from, next) => {
      if (!to.params.package) {
        next({ name: 'home' }); // Redirect to Home or another page
      } else {
        next(); // Continue to RegisterView
      }
    }
  },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: HomeView },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
